<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('yearlyPaymentList.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('yearlyPaymentList.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <div class="row">
      <div class="col-md-12">
        <ts-card>
          <ts-card-wrapper>
            <a-tabs :default-active-key="activeTab" v-model="activeTab">
              <a-tab-pane :key="1" tab="By Class">
               <div style="min-height: calc(90vh - 140px);">
                <YearlyByClass v-if="activeTab == 1"/>
               </div>
              </a-tab-pane>
              <a-tab-pane :key="2" tab="By Service" force-render>
               <div style="min-height: calc(90vh - 140px);">
                <ByService v-if="activeTab == 2"/>
               </div>
              </a-tab-pane>
              <a-tab-pane :key="3" tab="Admin Fee">
               <div style="min-height: calc(90vh - 140px);">
                <AdminFee />
               </div>
              </a-tab-pane>
            </a-tabs>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { YearlyByClass, ByService, AdminFee } from './components';
export default {
  name: 'yearlyPaymentList',
  components: {
    YearlyByClass, ByService, AdminFee
  },
  data() {
    return {
      activeTab: 1
    }
  },
}
</script>
